module.exports = __webpack_public_path__ + "img/tuition_layout2.7c58953c.png";